import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const rockeldConfig: TSPConfig = {
  key: 'rockeld',
  name: 'RockELD',
  category: TSPCategory.API_KEY,
  helpText:
    'Please request an API Key from RockELD support. Then input it here.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default rockeldConfig;
